<template>
  <div>
    <b-row>
      <b-col cols="3" style="padding-right: 0;height: 100vh;overflow-y: auto;max-width: 19%;">
        <SidebarMenu
          :menu="menu"
          :relative="true"
          :width="'15rem'"
          :showOneChild="true"
          :theme="'black-theme'"
        >
          <span slot="dropdown-icon">
            <font-awesome-icon icon="caret-square-down" />
          </span>
        </SidebarMenu>
      </b-col>
      <b-col cols="9" style="margin-left: 30px;">
        <transition name="fade">
          <router-view />
        </transition>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { SidebarMenu } from "vue-sidebar-menu";
export default {
  name: "PriSettingsPage",
  components: {
    SidebarMenu
  },
  data() {
    return {
      menu: [
        {
          href: "/pri-settings/general-page",
          title: "General Settings"
        },
        {
          href: "/pri-settings/google-custom-search-engine",
          title: "Google Custom Search Engine"
        },
        {
          href: "/pri-settings/google-custom-search-engine-url",
          title: "Custom Search Engine Url"
        },
        {
          href: "/pri-settings/public-listed-company",
          title: "Public Listed Company"
        },
        {
          href: "/pri-settings/due-diligence-categories",
          title: "Due Diligence Categories"
        },
        {
          href: "/pri-settings/filtered-keywords",
          title: "Stop Words"
        },
        {
          href: "/pri-settings/departments-page",
          title: "Departments"
        },

        {
          title: "Pri Settings",
          child: [
            {
              href: "/pri-settings/configurable-pri",
              title: "Configurable Pri"
            },
            {
              href: "/pri-settings/control-group-categories",
              title: "Control Groups"
            },
            {
              href: "/pri-settings/pri-control-group-categories-population",
              title: "Control Groups Population"
            },
            {
              href: "/pri-settings/benchmark-third-parties",
              title: "Benchmark Third Parties"
            }
          ]
        }
      ]
    };
  },
  computed: {},
  methods: {},
  mounted() {}
};
</script>

<style scoped>
</style>
